/**
 * Instancia unica de la sonda.
 *
 * Hay un solo socket por pestaña y una sola conexion que medir, asi que la
 * sonda es un singleton de modulo. Se evita el `provide`/`inject` de Vue a
 * proposito: `initProvide` corre antes del hook `created`, que es donde
 * `PanelContainer` recien tiene el socket armado.
 */

import WebSocket from '@/socket';
import NetworkProbe from './probe';

let instance: NetworkProbe | null = null;

/** Arranca la sonda la primera vez. Llamadas siguientes devuelven la misma. */
export function startNetworkProbe(socket: WebSocket): NetworkProbe {
    if (!instance) {
        instance = new NetworkProbe(socket);
        instance.start();
    }

    return instance;
}

/** `null` si el panel todavia no armo el socket. */
export function networkProbe(): NetworkProbe | null {
    return instance;
}

/** Solo para los tests, que necesitan partir de cero. */
export function resetNetworkProbe(): void {
    if (instance) {
        instance.stop();
    }

    instance = null;
}
